module.exports = __webpack_public_path__ + "static/og-8e1540d4c01bbd70a56ad66674f10721.png";